import Vue from 'vue'
import Vuex from 'vuex'

// import auxiliary store modules
import foodPreferences from './foodPreferences'
import login from './login'
import menu from './menu'
import people from './people'
import schedule from './schedule'
import data from './data'
import signup from './signup'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    foodPreferences: foodPreferences,
    login: login,
    menu: menu,
    people: people,
    schedule: schedule,
    data: data,
    signup: signup,
  },
  state: {
    
  },

  actions: {
    
  },

  mutations: {

  },

  getters: {

  },

})
